export default "__VITE_ASSET__c4395d48__"